import { runningClientSide } from './running';

export const getSubDomain = (hostname?: string): string => {
  if (!runningClientSide()) {
    return 'www';
  }

  const host = hostname ?? window.location.host;

  return host.split('.')[0];
};

export const isProductionDomain = (): boolean => {
  if (!runningClientSide()) return false;
  if (window.location.hostname.includes('www.benzinga.com')) {
    return true;
  }
  return false;
};

export const isSandboxDomain = (): boolean => {
  if (!runningClientSide()) return false;
  if (window.location.hostname.includes('bzsbx.benzinga.com')) {
    return true;
  }
  return false;
};

export const isStagingDomain = (): boolean => {
  if (!runningClientSide()) return false;
  const stagingSites = ['bz.zingbot.bz', 'wwwbeta.benzinga.com'];
  if (stagingSites.includes(window.location.hostname)) {
    return true;
  }
  return false;
};

export const isBetaSite = (): boolean => {
  if (!runningClientSide()) return false;
  const site = 'wwwbeta.benzinga.com';
  const host = window.location.hostname;
  return host.includes(site);
};

export const isStagingOrSandboxDomain = (): boolean => {
  return isStagingDomain() || isSandboxDomain();
};
